import Debug from '@/util/debug';
import Dropzone from 'vue2-dropzone';
import clone from 'clone';

const debug = Debug('file-upload');

export default {
  dependencies: [
    'apiKeyService',
    'adApiService',
  ],
  components: {
    'drop-zone': Dropzone,
  },
  props: {
    images: Array,
  },
  data() {
    return {
      error: null,
      uploadUrl: this.adApiService.getApiUrl('upload'),
      internalImages: [],
    };
  },
  computed: {
    dropzoneOptions() {
      return {
        headers: {
          'X-Auth': `Bearer ${this.apiKeyService.getKey()}`,
        },
        thumbnailWidth: 133,
        thumbnailHeight: 133,
        maxFiles: 50,
        maxFilesize: 200, // megabytes
        timeout: 0,
        acceptedFiles: '.pdf,.jpeg,.jpg,.png,.gif,.mp4,.mov,.qt,.avi,.csv,.txt,.xls,.xlsx,.doc,.docx',
        addRemoveLinks: true,
        dictDefaultMessage: this.$t('draft_field.placeholder.images'),
        dictRemoveFile: null,
        dictCancelUpload: this.$t('terms.misc.cancel'),
        dictCancelUploadConfirmation: this.$t('terms.misc.confirm'),
        autoProcessQueue: true,
      };
    },
  },
  beforeDestroy() {
    this.apiKeyService.getEventBus().$off('changedApiKey', this.onApiKeyChanged);
  },
  mounted() {
    this.apiKeyService.getEventBus().$on('changedApiKey', this.onApiKeyChanged);
    this.internalImages = clone(this.images);

    // This double-fetch fixes chrome (or s3) bug
    // https://bugs.chromium.org/p/chromium/issues/detail?id=409090
    // https://stackoverflow.com/a/34496683
    Promise.all(this.internalImages.map(image => fetch(image.path)))
      .then(() => this.internalImages.forEach(image => {
        // Force file to be "accepted"
        image.accepted = true;
        this.$refs.uploadImages.manuallyAddFile(image, image.path, null, 'anonymous');
        this.$refs.uploadImages.dropzone.files.push(image);
      }))
      .catch(err => debug.error('Error while loading images:', err));
  },
  methods: {
    onApiKeyChanged() {
      this.headers = {
        'X-Auth': `Bearer ${this.apiKeyService.getKey()}`,
      };
    },
    dzSuccess(file, response) {
      debug.info('Success %o, response %o', file, response);
      // Add file id to use it later (when removing it)
      file.id = response.result.id;
      file.path = response.result.path;

      this.internalImages.push(response.result);
      this.emitChanges();
    },
    dzError(file) {
      debug.error('Error file uploading %o', file);
      const elem = file.previewElement.querySelector('.dz-error-message');
      if (elem) {
        if (file.xhr) {
          const response = JSON.parse(file.xhr.response);
          elem.textContent = response.errors ? response.errors.join(', ') : this.$t('error.upload-file');
        }
      }
      this.error = true;
    },
    dzRemovedFile(file) {
      debug.info('Removed file %o', file);
      this.internalImages = this.internalImages.filter(img => file.id !== img.id);
      this.retryFailed();
      this.emitChanges();
    },
    retryFailed() {
      debug.info('Retry to upload failed images');
      const dz = this.$refs.uploadImages;
      const rejectedFiles = dz.getRejectedFiles();

      if (rejectedFiles.length) {
        const singleFile = rejectedFiles[0];

        singleFile.previewElement.classList.remove('dz-error', 'dz-complete');
        singleFile.status = 'queued';
        singleFile.accepted = true;

        dz.processQueue();
      }
    },
    emitChanges() {
      this.error = false;
      this.$emit('update:images', this.internalImages.map(img => ({
        id: img.id,
        name: img.name,
        path: img.path,
        size: img.size,
      })));
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/file-upload/FileUpload.js